import { useController } from 'react-hook-form';

import { DateInput, DateInputProps } from '@mantine/dates';
import '@mantine/dates/styles.css';

type DateFieldProps = DateInputProps & {
    name: string;
};

const DateField = ({ name, ...props }: DateFieldProps) => {
    const {
        field: { onChange, ...field },
        fieldState: { isTouched, error },
    } = useController({ name });

    return (
        <DateInput
            clearable
            {...field}
            value={field.value ? new Date(field.value) : null}
            styles={{ input: { lineHeight: '1em' } }}
            error={isTouched && error?.message}
            onChange={(value) => {
                onChange(value);
            }}
            {...props}
        />
    );
};

export { DateField };
